import React from "react";
import { Box, Stack, Typography } from "@mui/material";

interface AuthCardIntroProps {
  title: string;
  subtitle: React.ReactNode;
}

export const AuthCardIntro: React.FC<AuthCardIntroProps> = ({
  title,
  subtitle,
}) => (
  <Stack spacing={1}>
    <Typography variant="h6" component="h1">
      {title}
    </Typography>
    <Typography variant="body1" color="text.secondary">
      {subtitle}
    </Typography>
  </Stack>
);
